import React from "react";
import { ContactGroupIcon, Flex, SpeakerPersonIcon } from "@fluentui/react-northstar";
import { SearchEntityTypeEnum } from "view360Card/models/SearchEntityTypeEnum";
import classNames from "classnames";

export interface SearchEntityTypeIconProps {
    entityType: SearchEntityTypeEnum;
    additionalClassName?: string;
    size?: "smallest" | "smaller" | "small" | "medium" | "large" | "larger" | "largest";
}

export const SearchEntityTypeIcon: React.FC<SearchEntityTypeIconProps> = (props) => {
    const defaultSize = "medium";

    return (
        <Flex className={classNames(props.additionalClassName)}>
            {props.entityType === SearchEntityTypeEnum.Intermediary && (
                <ContactGroupIcon outline size={props.size ?? defaultSize} />
            )}
            {props.entityType === SearchEntityTypeEnum.SalesPerson && (
                <SpeakerPersonIcon outline size={props.size ?? defaultSize} />
            )}
        </Flex>
    );
};
